
import { EAgentUserActiveStatus, IRoleOptionsItem, IUserRoleDetail, IRoleTreeItem } from '../../types/common';
import { IAddPlatformUsers, IEditDataPermission, IPlatformUsersParam, IPlatformUsers, IUpdateDataPermission, IUserRoleParams } from '../../types/user-center/platform';
import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';

const hostUrl = getHostbaseUrl();

/**
 * 用户中心 - 平台用户数据查询
 */
export async function queryPlatformUsers(param: IPlatformUsersParam) {
  let data = [] as IPlatformUsers[];
  let total = 0;

  param = JSON.parse(JSON.stringify(param)) as IPlatformUsersParam;

  try {
    const { code, context, message } = await Http.post<{ data: IPlatformUsers[]; total: number }>(`${hostUrl}/iam/identity/saas/list`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: IPlatformUsers[]; total: number };

      data = items || [];
      total = all || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 用户中心 - 平台用户 - 激活/锁定
 */
export async function changeUsersActiveStatus(identityId: number, activated: EAgentUserActiveStatus) {
  try {
    const { code, message } = await Http.put<void>(`${hostUrl}/iam/identity/status`, {
      identityId,
      activated,
    });

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 用户中心 - 平台用户 - 重置密码
 */
export async function resetUsersPassword(identityId: number) {
  try {
    const { code, message } = await Http.put<void>(`${hostUrl}/iam/identity/reset-password?identityId=` + identityId);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 用户中心 - 平台用户 - 删除
 */
export async function deleteUsers(identityId: number) {
  try {
    const { code, message } = await Http.delete<void>(`${hostUrl}/iam/identity?identityId=${identityId}`);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 用户中心 - 平台用户 - 角色列表
 */
export async function queryRoleList(isDisplay?: boolean) {
  let data = [] as IRoleOptionsItem[];

  try {
    const { code, context, message } = await Http.post<Array<IRoleOptionsItem>>(`${hostUrl}/iam/role/saas/list`, { isDisplay });

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || [];

      data = res || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return { data };
}

/**
 * 用户中心 - 平台用户 - 查询用户详情
 */
export async function querySassAuth(identityId: number) {
  let data = {} as IEditDataPermission;

  try {
    const { code, context, message } = await Http.get<IEditDataPermission>(`${hostUrl}/iam/identity/saas/auth`, { identityId });

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || {};

      data = res || {};
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 用户中心 - 平台用户 - 更新数据权限
 */
export async function updateSassAuth(params: IUpdateDataPermission) {

  try {
    const { code, message } = await Http.put<IEditDataPermission>(`${hostUrl}/iam/identity/saas/auth`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 用户中心 - 平台用户 - 新增用户
 */
export async function addPlatformUsers(param: IAddPlatformUsers) {
  let data = {} as { warnCode: number; extra: { name: string }};

  try {
    const { code, context, message } = await Http.post<any>(`${hostUrl}/iam/identity/saas`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || {};

      data = res || {};
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return { data };
}

/**
 * 用户中心 - 平台用户 - 编辑用户
 */
export async function editUsers(param: IAddPlatformUsers) {

  try {
    const { code, message } = await Http.put<any>(`${hostUrl}/iam/identity`, param);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}

/**
 * 用户中心 - 平台、代理商、企业、服务商角色查询
 */
export async function queryUserRoleList() {
  let data = [] as IRoleTreeItem[];

  try {
    const { code, context, message } = await Http.get<IRoleTreeItem[]>(`${hostUrl}/iam/role/list`);

    if (code === EAxiosResponseCode.Succeed) {
      const items = context || [] as IRoleTreeItem[];

      data = items || [] as IRoleTreeItem[];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 用户中心 - 平台、代理商、企业角色查询详情
 */
export async function queryUserRoleDetail(roleId: number) {
  let data = {} as IUserRoleDetail;

  try {
    const { code, context, message } = await Http.get<IUserRoleDetail>(`${hostUrl}/iam/role/detail`, { roleId });

    if (code === EAxiosResponseCode.Succeed) {
      const items = context || {} as IUserRoleDetail;

      data = items || {} as IUserRoleDetail;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 用户中心 - 平台、代理商、企业角色新增/编辑
 */
export async function updateUserRole(params: {roleId?: number; roleName: string}, isAdd: boolean) {

  const url = `${hostUrl}/iam/role`;

  try {
    const { code, message } = isAdd ? await Http.post<void>(url, params) : await Http.put<void>(url, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 用户中心 - 平台、代理商、企业角色 - 保存配置
 */
export async function saveUserRole(params: IUserRoleParams) {

  try {
    const { code, message } = await Http.put<void>(`${hostUrl}/iam/role/menu`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 用户中心 - 平台、代理商、企业角色 - 删除
 */
export async function deleteUserRole(roleId: number) {

  try {
    const { code, message } = await Http.delete<void>(`${hostUrl}/iam/role?roleId=${roleId}`);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 用户中心 - 获取身份列表
 */
export async function queryPlatformListOwner() {
  let data = [] as IPlatformUsers[];

  try {
    const { code, context, message } = await Http.get<IPlatformUsers[]>(`${hostUrl}/iam/identity/saas/list-owner`);

    if (code === EAxiosResponseCode.Succeed) {
      data = context || [] as IPlatformUsers[];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}
